import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const StyledDataTableRowHoverButton = styled.div`
  visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
`;

const StyledDataTableRowHoverButtonContent = styled.div`
  color: #006633;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  button {
      margin-right: 24px;
   },
   button:last-child {
      margin-right: 0px;
   },
`;

const DataTableRowHoverButton = ({ children }) => (
  <StyledDataTableRowHoverButton>
    <StyledDataTableRowHoverButtonContent>{children}</StyledDataTableRowHoverButtonContent>
  </StyledDataTableRowHoverButton>
);

DataTableRowHoverButton.propTypes = {
  children: PropTypes.node,
};

export default DataTableRowHoverButton;
